import { type AppPairingPageProps } from '../../../chulak/ChulakSession';
import EmbeddedUnsupportedScreen from './UnsupportedScreen';

/** Apps that ask for a pairing code have no embedded screen yet. */
export default function EmbeddedAppPairingPage({
  app,
  onBack,
}: AppPairingPageProps) {
  return <EmbeddedUnsupportedScreen app={app} onBack={onBack} />;
}
